// Traducciones específicas para la página de consignaciones - Español
export const consignmentsEs = {
  hero: {
    title: 'Consignaciones',
    description:
      'Consigna tu vehículo con nosotros y maximiza tu beneficio. Nos encargamos de todo el proceso de venta.',
  },
  form: {
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    brand: 'Marca',
    brandPlaceholder: 'Selecciona una marca',
    model: 'Modelo',
    modelPlaceholder: 'Selecciona un modelo',
    year: 'Año',
    mileage: 'Kilometraje',
    condition: 'Condición del Vehículo',
    message: 'Detalles adicionales',
    submit: 'Enviar Solicitud',
  },
  info: {
    advantagesTitle: 'Ventajas de Consignar con Nosotros',
    benefitsTitle: 'Beneficios de la consignación',
    benefitsList: {
      item1: 'Maximiza el valor de venta de tu vehículo',
      item2: 'No tienes que preocuparte por el proceso de venta',
      item3: 'Amplia exposición a clientes potenciales',
      item4: 'Evita trámites y gestiones complicadas',
    },
    processTitle: 'Proceso de consignación',
    processList: {
      step1: 'Evaluación y tasación del vehículo',
      step2: 'Firma del contrato de consignación',
      step3: 'Exhibición y promoción',
      step4: 'Gestión de ofertas y negociaciones',
      step5: 'Pago rápido una vez vendido',
    },
    directContactTitle: 'Contacto Directo',
    emailLabel: 'Email',
    phoneLabel: 'Teléfono',
  },
  embed: {
    infoTitle: '¿Cómo funciona?',
    steps: [
      { title: 'Envía tus datos', desc: 'Completa el formulario con la información de tu vehículo.' },
      { title: 'Evaluación', desc: 'Nuestro equipo evalúa tu vehículo y te contactamos.' },
      { title: 'Publicación', desc: 'Publicamos tu vehículo en múltiples plataformas.' },
      { title: 'Venta', desc: 'Gestionamos todo el proceso hasta cerrar la venta.' },
    ],
    benefitsTitle: 'Beneficios',
    benefits: ['Publicación en múltiples plataformas', 'Gestión completa de la venta', 'Mejor precio garantizado'],
  },
};

